<template>
  <div class="space-y-6">
    <!-- YooKassa -->
    <section class="space-y-4">
      <h4 class="text-lg font-semibold text-hui-foreground border-b border-hui-divider pb-2">YooKassa</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiKitInput v-model="form.kassa.yookassa_shop_id" label="YooKassa Shop ID" placeholder="Shop ID" />
        <UiKitInput v-model="form.kassa.yookassa_secret_key" label="YooKassa Secret Key" type="password" placeholder="Secret Key" />
        <UiKitInput v-model="form.kassa.yookassa_shop_id_test" label="YooKassa Test Shop ID" placeholder="Test Shop ID" />
        <UiKitInput v-model="form.kassa.yookassa_secret_key_test" label="YooKassa Test Secret Key" type="password" placeholder="Test Secret Key" />
      </div>
    </section>

    <!-- Т-Бизнес -->
    <section class="space-y-4">
      <h4 class="text-lg font-semibold text-hui-foreground border-b border-hui-divider pb-2">Т-Бизнес</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiKitInput v-model="form.kassa.tbusiness_terminal_id" label="Т-Бизнес Terminal ID" placeholder="Terminal ID" />
        <UiKitInput v-model="form.kassa.tbusiness_secret_key" label="Т-Бизнес Secret Key" type="password" placeholder="Secret Key" />
        <UiKitInput v-model="form.kassa.tbusiness_terminal_id_test" label="Т-Бизнес Test Terminal ID" placeholder="Test Terminal ID" />
        <UiKitInput v-model="form.kassa.tbusiness_secret_key_test" label="Т-Бизнес Test Secret Key" type="password" placeholder="Test Secret Key" />
      </div>
    </section>

    <!-- Альфа-Банк -->
    <section class="space-y-4">
      <h4 class="text-lg font-semibold text-hui-foreground border-b border-hui-divider pb-2">Альфа-Банк</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiKitInput v-model="form.kassa.alfa_merchant_id" label="Альфа-Банк Merchant ID" placeholder="Merchant ID" />
        <UiKitInput v-model="form.kassa.alfa_terminal_id" label="Альфа-Банк Terminal ID" placeholder="Terminal ID" />
        <UiKitInput v-model="form.kassa.alfa_secret_key" label="Альфа-Банк Secret Key" type="password" placeholder="Secret Key" />
        <UiKitInput v-model="form.kassa.alfa_merchant_id_test" label="Альфа-Банк Test Merchant ID" placeholder="Test Merchant ID" />
        <UiKitInput v-model="form.kassa.alfa_terminal_id_test" label="Альфа-Банк Test Terminal ID" placeholder="Test Terminal ID" />
        <UiKitInput v-model="form.kassa.alfa_secret_key_test" label="Альфа-Банк Test Secret Key" type="password" placeholder="Test Secret Key" />
      </div>
    </section>

    <!-- Настройки тестирования -->
    <section class="space-y-4">
      <h4 class="text-lg font-semibold text-hui-foreground border-b border-hui-divider pb-2">Настройки тестирования</h4>
      <UiKitCheckbox v-model="form.kassa.is_test" color="primary">Использовать тестовый режим</UiKitCheckbox>
    </section>

    <!-- Активный провайдер -->
    <section class="space-y-4">
      <h4 class="text-lg font-semibold text-hui-foreground border-b border-hui-divider pb-2">Активный провайдер</h4>
      <UiKitRadioGroup v-model="form.kassa.active_provider" orientation="horizontal">
        <UiKitRadio value="yookassa">ЮKassa</UiKitRadio>
        <UiKitRadio value="tbusiness">Т-Бизнес</UiKitRadio>
        <UiKitRadio value="alfabank">Альфа-Банк</UiKitRadio>
      </UiKitRadioGroup>
    </section>

    <!-- Footer -->
    <div class="flex justify-end gap-3 pt-4 border-t border-hui-divider">
      <UiKitButton type="button" color="default" variant="flat" @click="modalStore.close()">
        Отмена
      </UiKitButton>
      <UiKitButton type="button" color="primary" @click="handleSubmit">
        Сохранить
      </UiKitButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useModalStore } from '@shared/model'
import type { PaymentSettings } from '@entities/institution'

const emit = defineEmits(['update'])

const modalStore = useModalStore()

const form = ref({
  kassa: {
    is_test: false,
    yookassa_shop_id: '',
    yookassa_secret_key: '',
    yookassa_shop_id_test: '',
    yookassa_secret_key_test: '',
    tbusiness_terminal_id: '',
    tbusiness_secret_key: '',
    tbusiness_terminal_id_test: '',
    tbusiness_secret_key_test: '',
    alfa_merchant_id: '',
    alfa_terminal_id: '',
    alfa_secret_key: '',
    alfa_merchant_id_test: '',
    alfa_terminal_id_test: '',
    alfa_secret_key_test: '',
    active_provider: 'yookassa', // Добавляем поле для выбора активного провайдера
  } as PaymentSettings,
})

// Инициализация формы данными из modalStore
if (modalStore.modalData?.institution?.kassa) {
  form.value.kassa = { ...modalStore.modalData.institution.kassa }
}

const handleSubmit = () => {
  emit('update', { kassa: form.value.kassa })
  modalStore.close()
}
</script>
